import { jsonHeadersWithAuth } from '../utils/webAuth';

const API_BASE = import.meta.env.VITE_API_URL || 'https://verbum-api-production.up.railway.app/api';

function getApiOrigin() {
  const base = API_BASE.replace(/\/api\/?$/, '');
  return base || API_BASE;
}

/**
 * Картинка по стиху: из кэша для всех; генерация на сервере только для telegram_id из списка.
 * @returns {{ imageUrl: string|null, notInCache: boolean, canGenerate: boolean }}
 */
export async function getVerseImage(bookId, chapter, verse, translation = null) {
  const body = {
    bookId: Number(bookId),
    chapter: Number(chapter),
    verse: Number(verse),
  };
  if (translation != null && translation !== '') body.translation = String(translation);
  const res = await fetch(`${API_BASE}/verse-image`, {
    method: 'POST',
    headers: jsonHeadersWithAuth({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const error = new Error(err.error || res.statusText || 'Failed to load image');
    if (err?.code) error.code = err.code;
    if (err?.requestType) error.requestType = err.requestType;
    throw error;
  }
  const data = await res.json();
  const imageUrl = data.imageUrl ? getApiOrigin() + data.imageUrl : null;
  return {
    imageUrl,
    notInCache: !!data.notInCache,
    canGenerate: !!data.canGenerate,
  };
}

/**
 * Может ли текущий пользователь запускать генерацию иллюстраций (есть в VerseImage:AllowedTelegramIds).
 */
export async function isVerseImageAllowed() {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') : null;
  if (!token) return false;

  const res = await fetch(`${API_BASE}/verse-image/allowed`, {
    headers: jsonHeadersWithAuth(),
  });
  if (!res.ok) return false;
  const data = await res.json().catch(() => ({}));
  return !!data.allowed;
}
